import { InjectionToken } from '@angular/core';

export interface ApiConfig {
  readonly gameEndpoint: string;
  readonly markEndpoint: string;
  readonly prizeEndpoint: string;
}

export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG');
